import gsap from 'gsap'

const body = document.querySelector('body')
var buttons = document.querySelectorAll('.accordionButton')
var icons = document.querySelectorAll('.icon')
var activeElement = null;
// console.log(buttons)

gsap.set(body, {
    visibility: 'visible',
})

buttons.forEach((button, index) => {
    button.addEventListener('click', (e) => {
        var correspondingIcon = button.lastChild;
        // console.log(correspondingIcon)
        var correspondingTextBox = button.nextElementSibling
        correspondingTextBox.classList.toggle('active')
        // console.log(correspondingTextBox.classList)
        activeElement = correspondingTextBox;
        collapseOtherElements(buttons, activeElement)
        if (!correspondingTextBox.classList.contains("active")) {
            gsap.to(correspondingTextBox, {
                maxHeight: 0,
                duration: 0.6,
                ease: 'expo.out'
            })
            gsap.to(correspondingIcon, {
                rotate: 0,
                duration: 0.6,
                ease: 'sine.out'
            })
        } else {
            gsap.to(correspondingTextBox, {
                maxHeight: '1000px',
                duration: 0.8,
                ease: 'expo.in'
            })
            gsap.to(correspondingIcon, {
                rotate: 45,
                duration: 0.8,
                ease: 'sine.in'
            })
        }
    })
})

function collapseOtherElements(allBaseElements, activeBaseElement) {
    allBaseElements.forEach((element, index) => {
        const correspondingIcon = element.lastChild;
        const correspondingElement = element.nextElementSibling;
        if (correspondingElement.classList.contains('active') && correspondingElement != activeBaseElement) {
            correspondingElement.classList.remove('active')
            gsap.to(correspondingElement, {
                maxHeight: 0,
                duration: 0.3,
                ease: 'expo.out'
            })
            gsap.to(correspondingIcon, {
                rotate: 0,
                duration: 0.3,
                ease: 'sine.out'
            })
        }
    })
}
